import { Component, AfterViewInit, ViewContainerRef, OnInit, NgZone, ChangeDetectorRef  } from '@angular/core';
import { MdDialog } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Documento } from '../../../../models';
import { LoginService } from '../../../../services/';

@Component({
  selector: 'qs-detallejustificantes',
  templateUrl: './detallejustificantes.component.html',
  styleUrls: ['./detallejustificantes.component.scss'],
})

export class DetalleJustificantesComponent implements OnInit, AfterViewInit {

  public documento: any;
  public pdfUrl: string;
  public nombrePaciente: string;
  public dniPaciente: string;
  public nombreProfesional: string;

  constructor(private sanitizer: DomSanitizer, private _loginService: LoginService) {}

  // tslint:disable-next-line: no-empty
  ngOnInit(): void {

  }

  // tslint:disable-next-line: no-empty
  ngAfterViewInit(): void {

  }

  print(): void {
    let printContents: string;
    let popupWin: Window;
    printContents = document.getElementById('bloquePrint').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
            #botonImprimir{
              display:none;
            }
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`,
    );
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/documentos/detallejustificantes/detallejustificantes.component.ts